import { render, staticRenderFns } from "./MailCallbackWrapper.vue?vue&type=template&id=537d6168&scoped=true&"
import script from "./MailCallbackWrapper.vue?vue&type=script&lang=ts&"
export * from "./MailCallbackWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./MailCallbackWrapper.vue?vue&type=style&index=0&id=537d6168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d6168",
  null
  
)

export default component.exports